import request from "@/router/axios";
export const list = (resId) => {
  return request({
    url: `/api/jc/resource/route/list`,
    method: "post",
    data: {
      filterParams: [
        {
          name: "resId",
          value: resId,
        },
      ],
      order: "createTime",
      isDesc: false,
    },
  });
};

export const add = (data) => {
  return request({
    url: `/api/jc/resource/route/add`,
    method: "post",
    data,
  });
};
export const edit = (data) => {
  return request({
    url: `/api/jc/resource/route/edit`,
    method: "post",
    data,
    timeout: 120000,
  });
};
export const remove = (ids) => {
  return request({
    url: `/api/jc/resource/route/del`,
    method: "post",
    params: {
      ids,
    },
  });
};
